import React, { useState, useCallback, useEffect } from "react";
import connect from "react-redux/es/connect/connect";
import { createSelector } from "reselect";
import Video, { isSupported, createLocalTracks, createLocalVideoTrack } from "twilio-video";
import { alertSelectors } from "../../../common/redux/selectors";
import { itemService, globalService as gs } from "../../../common/services";
import Lobby from "./Lobby";
import Room from "./Room";

const VideoChat = ({ item, extra, dispatch }) => {
    const [username, setUsername] = useState(item && item.user.email);
    const [roomName, setRoomName] = useState(extra && extra.sid);
    const [room, setRoom] = useState(null);
    const [connecting, setConnecting] = useState(false);

    const handleUsernameChange = useCallback((event) => {
        setUsername(event.target.value);
    }, []);

    const handleRoomNameChange = useCallback((event) => {
        setRoomName(event.target.value);
    }, []);

    //console.log('item11111', item, extra);

    const handleSubmit = useCallback(
        async (event) => {
            event.preventDefault();
            setConnecting(true);
            const data = await itemService.meeting("POST", null, { item_id: item.id, status: 'token' }).then(token => {
                if(token.code) {
                    return token;
                } else {
                    dispatch(alertSelectors.error(token.message));
                    return false;
                }
            })
            .catch(exception => {
                gs.showErrors(dispatch, exception, alertSelectors);
                setConnecting(false);
            });

            console.log('asdaskjhdkjash', data);
            navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then(function(mediaStream){
                console.log('mediaStream', mediaStream);
            });

            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {  
                console.log("enumerateDevices() not supported.");
                return;
            }

            // List cameras and microphones.
            navigator.mediaDevices.enumerateDevices().then(function(devices) {
                devices.forEach(function(device) {
                    console.log(device.kind + ": " + device.label + " id = " + device.deviceId);
                });
            })
            .catch(function(err) {
                console.log(err.name + ": " + err.message);
            });

            const tracks = await createLocalTracks({
                audio: true,
                video: { facingMode: 'user' }
            });

            // console.log('trackstrackstracks', tracks);
            
            if(isSupported) {
                console.log('isSupported', isSupported);
                Video.connect(data.twilioToken, {
                    name: roomName,
                    tracks
                })
                .then((room) => {
                    setConnecting(false);
                    setRoom(room);
                })
                .catch(exception => {
                    const error = exception instanceof TypeError;
                    const errorMessage = 'navigator.MediaDevices.getUserMedia error: ' + exception.message + ' ' + exception.name;
                    console.log('exception', error, exception, errorMessage);
                    dispatch(alertSelectors.error(errorMessage));
                    setConnecting(false);
                });
                // // Capture the back facing camera.
                // const backFacingTrack = await createLocalVideoTrack({ facingMode: 'environment' });

                // // Switch to the back facing camera.
                // const frontFacingTrack = tracks.find(track => track.kind === 'video');
                // frontFacingTrack.stop();
            } else {
                console.error('This browser is not supported by twilio-video.js.');
            }
        },
        [roomName, username]
    );

    const handleLogout = useCallback(() => {
        setRoom((prevRoom) => {
            if (prevRoom) {
                prevRoom.localParticipant.tracks.forEach((trackPub) => {
                    trackPub.track.stop();
                });
                prevRoom.disconnect();
            }
            return null;
        });
    }, []);

    useEffect(() => {
        if (room) {
            const tidyUp = (event) => {
                if (event.persisted) {
                    return;
                }
                if (room) {
                    handleLogout();
                }
            };
            window.addEventListener("pagehide", tidyUp);
            window.addEventListener("beforeunload", tidyUp);
            return () => {
                window.removeEventListener("pagehide", tidyUp);
                window.removeEventListener("beforeunload", tidyUp);
            };
        }
    }, [room, handleLogout]);

    let render;
    if (room) {
        render = (
            <Room roomName={roomName} room={room} handleLogout={handleLogout} />
        );
    } else {
        render = (
            <Lobby
                username={username}
                roomName={roomName}
                handleUsernameChange={handleUsernameChange}
                handleRoomNameChange={handleRoomNameChange}
                handleSubmit={handleSubmit}
                connecting={connecting}
                item={item && item}
            />
        );
    }
    return render;
};

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(VideoChat);
